import type { ReactNode } from 'react';

type TilePastel = 'pink' | 'teal' | 'mint' | 'lilac';

interface TileProps {
  /** The one bold clause that opens the caption. */
  lead: string;
  /** The plain sentence that follows it. */
  children: ReactNode;
  /** The product fragment or art inside the grey field. */
  art: ReactNode;
  /** Optional pastel field behind the art. Omit for the plain grey tile. */
  pastel?: TilePastel;
  /** Extra classes on the art field, e.g. flex centring. */
  artClassName?: string;
}

/** A figure: grey tile holding one thing, caption with a bold lead-in. */
export const Tile = ({ lead, children, art, pastel, artClassName = '' }: TileProps) => (
  <figure className="min-w-0">
    <div className={`tile-art ${artClassName}`}>
      {pastel ? <div aria-hidden="true" className={`tile-pastel ${pastel}`} /> : null}
      {art}
    </div>
    <figcaption className="tile-caption">
      <strong>{lead}</strong> {children}
    </figcaption>
  </figure>
);
